export function profileList() {
  const query = `{
    profileList(filter: {}){
        id, name
    }
}`;

  return query;
}

export function profileListById(id) {
  const query = `{
    profileList(filter: {id: ${id}}){
        id, name
    }
}`;

  return query;
}

export function findItemTabletByProfile(profileId) {
  return `{
    findItemTabletByProfile(profileId: ${profileId}) {
      id
      profileId
      itemId
      itemName
      value
      label
    }
  }`;
}

export function findByProfileCommunicationTypes(profileId) {
  return `{
    findByProfileCommunicationTypes(profileId: ${profileId}) {
      id
      type
    }
  }`;
}

export function profileUsers(id) {
  const query = `{
    loadProfileAccessData(filter: { id: ${id} }) {
      availableUsers {
        id
        name
        value
        label
      }
      linkedUsers {
        id
        name
        value
        label
      }
    }
  }`;
  return query;
}

export function allTypesOfCommunication() {
  const query = `{
    findAllCommunicationTypes {
      id
      type
  }
  }`;
  return query;
}

export function allTypesOfCommunicationForAudit() {
  const query = `{
    findCommunicationTypesForAudit {
      id
      type
  }
  }`;
  return query;
}

export function tabletItens() {
  const query = `{
    findAllItemTablet {
        itemId
        itemName
    }
}`;
  return query;
}

export function profileFeatures(id) {
  const query = `{
    profileFeatures(filter: {id: ${id}}){
         id, profileId, featureId, featureName, featureType, fatherFeatureId, hasAcess, 
         childrens{id, profileId, featureId, featureName, featureType, fatherFeatureId, hasAcess}
    }
}`;
  return query;
}

export function profileSave(values) {
  const profileUsersSave = values.linkedUsers.map((item) => ({
    id: item.id,
    usuarioChatInterno: false,
    ativo: false,
    filterByStatus: false,
    pedagogicAdm: false,
    updaterId: 0,
    active: false,
    usuarioChat: false,
  }));

  let prifileCommunicationTypes = [];
  if (
    values.linkedTypecommunicationTypessComu &&
    values.linkedTypecommunicationTypessComu.length
  ) {
    prifileCommunicationTypes = values.linkedTypecommunicationTypessComu.map(
      (item) => ({
        id: item.id,
      })
    );
  }

  let profilesItemTablet = [];
  if (values.linkedItemsTablet && values.linkedItemsTablet.length) {
    profilesItemTablet = values.linkedItemsTablet.map((item) => ({
      itemId: item.id !== item.itemId ? item.value : item.itemId,
    }));
  }

  const mutationQuery = `mutation {    
    profileSave(profile: {
                    id: ${values.id ? values.id : 0},
                    name: "${values.name}",
                    accessToChat: false,
                    accessToInternal: false,
                    filterByStatus: false,
                    updaterId: 0,
                    profileUsers:${JSON.stringify(profileUsersSave).replace(
                      /"([^(")"]+)":/g,
                      '$1:'
                    )},
                    profileFeatures: ${JSON.stringify(
                      values.profileFeatures
                    ).replace(/"([^(")"]+)":/g, '$1:')},
                    itemsTablet: ${JSON.stringify(profilesItemTablet).replace(
                      /"([^(")"]+)":/g,
                      '$1:'
                    )},
                    communicationTypes: ${JSON.stringify(
                      prifileCommunicationTypes
                    ).replace(/"([^(")"]+)":/g, '$1:')},
                    },

    ){profile:id}
}`;

  return mutationQuery;
}

export function profileRemove(id) {
  const query = `mutation{
    profileRemove(id: ${id})}`;
  return query;
}
